export const Sizes = {
    header: 70,
}
